module.exports = __webpack_public_path__ + "assets/icon-conductor-tape40.ab22a215.svg";